import { Container } from 'react-bootstrap'
import './PaymentConfirmPage.css'

const PaymentConfirmPage = () => {

    return (
        <Container>
            <div className='Payment'>
                <img src="https://rsrnurburg.com/wp-content/uploads/2020/01/success-200x200.jpg" alt="payment" />
            </div>
        </Container>
    )
}

export default PaymentConfirmPage